import React, { createContext, useState } from "react";


export const ScoreCardContext = createContext();

export const ScoreCardProvider = ({ children }) => {
    const [challenge, setChallenge] = useState({
        challenge_type: "",
        challenged_team_id: "",
        challenged_team_name: "",
        challenged_team_pic: null,
        challenged_to: "",
        challenged_user_id: null,
        challenged_user_name: "",
        challenged_user_pic: "",
        challenger_id: "",
        challenger_name: "",
        challenger_pic: "",
        challenger_team_id: "",
        challenger_team_name: "",
        challenger_team_pic: null,
        coins: "",
        created_at: "",
        created_by: "",
        id: 21,
        location: "",
        match_date: "",
        match_time: "",
        notification_list_id: "",
        overs: "",
        personal_message: null,
        pitch: ""
    })

    return (
        <ScoreCardContext.Provider value={{ setChallenge, challenge }}>
            {children}
        </ScoreCardContext.Provider>
    )
}
